/**
 * cbpHorizontalMenu.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */

(function ($) {
    $.fn.extend({
        //cbpHorizontalMenu
        cbpHorizontalMenu: function (options) {
            var defaults = {
                //$listItems : $('.cbp-hrmenu'),
                //$menuItems : $listItems.children('a'),
                $body: $('body'),
                current: -1,
            };

            var options = $.extend({}, defaults, options);
            var $body = $('body');
            var current = -1;

            function init($linkItems, $items) {
                $linkItems.not('.cbp-ignore').on('click', $items, open);
                $items.on('click', function (event) {
                    event.stopPropagation();
                });
            }

            function open(event) {
                if (current !== -1) {
                    event.data.eq(current).removeClass('cbp-hropen');
                    event.data.eq(current).attr('aria-pressed', 'false');
                }

                var $item = $(event.currentTarget).parent('li'),
                    idx = $item.index();

                if (current === idx) {
                    $item.removeClass('cbp-hropen');
                    current = -1;
                    $item.children('a').attr('aria-pressed', 'false');
                } else {
                    $item.addClass('cbp-hropen');
                    $item.children('a').attr('aria-pressed', 'true');
                    current = idx;
                    //$body.off('click').on('click', event.data, close); // Adding .off('click') causes other events bound to body to stop working
                    $body.on('click', event.data, close);
                    $body.off('keyup').on('keyup', event.data, function (e) {
                        if (e.which === 27) {
                            close(e);
                        }
                    });
                    $('.menu-main_btn-close').on('click', event.data, close);

                    $('.menu-main_close-container').on('keyup', event.data, function (e) {
                        if (e.which === 13 || e.which === 32) {
                            close(e);
                        }
                    });
                }

                return false;
            }

            function close(event) {
                event.data.eq(current).removeClass('cbp-hropen');
                current = -1;
            }

            //Iterate over the current set of matched elements
            return this.each(function () {
                var o = options;
                var obj = $(this);
                var $items = $('> ul > li', obj);
                var $linkItems = $items.children('a');

                init($linkItems, $items);
            });
        },
    });
})(jQuery);
